import axios from 'axios';
import config from '../config';
import authService from './authService';

// Create axios instance for Oauth Client API
const oauthClientApi = axios.create({
    baseURL: `${config.API_BASE_URL}${config.ADMIN_API_PREFIX}/${config.ADMIN_API_VERSION}`,
    timeout: config.TIMEOUTS.API_REQUEST,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

// Request interceptor: add access token
oauthClientApi.interceptors.request.use(
    async (config) => {
        const token = await authService.getValidAccessToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor: handle 401
oauthClientApi.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                const newToken = await authService.getValidAccessToken();
                if (newToken) {
                    originalRequest.headers.Authorization = `Bearer ${newToken}`;
                    return oauthClientApi(originalRequest);
                } else {
                    authService.forceLogout();
                    return Promise.reject(new Error('Authentication failed'));
                }
            } catch (refreshError) {
                console.error('Token refresh failed:', refreshError);
                authService.forceLogout();
                return Promise.reject(refreshError);
            }
        }
        return Promise.reject(error.response?.data || error.message);
    }
);

const OauthClientService = {
    saveClient: async (payload) => {
        try {
            const response = await oauthClientApi.post(config.OAUTH_CLIENT.ENDPOINTS.REGISTER_CLIENT, payload);
            return response.data;
        } catch (error) {
            console.error('Error saving Oauth Client configuration:', error.message);
            throw error;
        }
    },

    regenerateCredentials: async (clientId) => {
        try {

            console.log('clientId>>>>>>>>'+clientId);

            const payload = {
                ids: [Number(clientId)]
            };

            const response = await oauthClientApi.post(
                config.OAUTH_CLIENT.ENDPOINTS.REGENERATE_CREDENTIALS,
                payload
            );

            return response.data;

        } catch (error) {
            console.error('Error regenerating credentials:', error.message);
            throw error;
        }
    },

    getClients: async (filters = {}) => {
        try {
            const response = await oauthClientApi.get(config.OAUTH_CLIENT.ENDPOINTS.GET_CLIENTS, {
                params: filters
            });
            return response.data;
        } catch (error) {
            console.error('Error getting Oauth Clients:', error.message);
            throw error;
        }
    },

    deleteClient: async (clientId) => {
        try {

            const payload = {
                ids: [Number(clientId)]
            };

            const response = await oauthClientApi.post(
                config.OAUTH_CLIENT.ENDPOINTS.DELETE_CLIENT,
                payload
            );

            return response.data;
        } catch (error) {
            console.error('Error deleting client:', error.message);
            throw error;
        }
    },
};

export default OauthClientService;